/* eslint-disable react/require-default-props */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react';
import { useLocation } from 'react-router-dom';
import {
  MESSAGE_CENTER_INBOX_PATH,
  DOCUMENT_CENTER_PATH,
  MESSAGE_CENTER_FAQ_PATH,
  MESSAGE_CENTER_CREATE_NEW_MESSAGE,
} from 'src/constants/routePaths';
import { Breadcrumb } from '@vwfs-bronson/bronson-react';
import globalConstants from 'src/constants/globalConstants';
import i18n from '../../../../localization/i18n';
import * as rk from '../../../../localization/resourceKeys';
import BackLink from '../sidebar-nav/BackLink';

interface TopBarProps {
  brand: string;
  country: string;
}

const TopBar: React.FC<TopBarProps> = ({ brand, country }: TopBarProps) => {
  const location = useLocation();
  const { pathname } = location;

  const paths = pathname.split('/');
  const current = paths.pop();

  const showlastItem = (() => {
    if (pathname.includes(`support-center`)) return false;
    return true;
  })();

  const isAudiBrand = brand.toLowerCase() === globalConstants.AUDI_BRAND;

  const isBackLinkVisible = (() => {
    // message back link is only visible and replace breadcrumbs only when user is in new-message section
    if (pathname.includes(`${MESSAGE_CENTER_CREATE_NEW_MESSAGE}`)) return true;

    const pattern = /(?:^|\/)message-center\/inbox\/\d+\/?$/;

    const isSelectedMessage = pattern.test(pathname);

    return isSelectedMessage;
  })();

  const currentLabel = (() => {
    if (pathname.includes(`${MESSAGE_CENTER_FAQ_PATH}`)) return i18n.t(rk.FAQ_COMPONENT_NAME);

    if (pathname.includes(`${MESSAGE_CENTER_INBOX_PATH}`)) return i18n.t(rk.MESSAGECENTER_COMPONENT_NAME);

    if (pathname.includes(`${DOCUMENT_CENTER_PATH}`)) return i18n.t(rk.DOCUMENT_CENTER_TITLE);

    return i18n.t(rk.MESSAGECENTER_COMPONENT_NAME);
  })();

  return (
    <div data-testid='topbar' className='u-mh u-mt' role='navigation' aria-label='main navigation'>
      {isBackLinkVisible ? (
        <div id='backLinkContainer' className='asidebar-nav__item__label'>
          <BackLink
            data-testid='back-link'
            label={i18n.t(rk.BACK_LINK)}
            mobile
            brand={isAudiBrand ? globalConstants.AUDI_BRAND : globalConstants.VW_BRAND}
          />
        </div>
      ) : (
        <>
          <Breadcrumb aria-label='help-center-breadcrumb'>
            <Breadcrumb.Item testId='link-item-home' href='../'>
              {i18n.t(rk.BACK_LINK_TOPBAR).toString()}
            </Breadcrumb.Item>
            <Breadcrumb.Item testId='link-item-support' href='./support-center'>
              {i18n.t(rk.MESSAGECENTER_SUPPORT_COMPONENT_NAME).toString()}
            </Breadcrumb.Item>
            {showlastItem && (
              <Breadcrumb.Item testId='link-item-current' href={current}>
                {currentLabel}
              </Breadcrumb.Item>
            )}
          </Breadcrumb>
        </>
      )}
    </div>
  );
};

export default TopBar;
